export const hasError = 'hasError';
export const getAllErrors = 'getAllErrors';
